import clsx from 'clsx'
import Link from 'next/link'

import { useMediaQueries } from '@/shared/lib/hooks/useMediaQueries'
import { Popover } from '@/shared/ui/Popover'
import { useTagTimer } from '@/shared/ui/tags'

import cl from './tag.module.scss'

type Tag = {
	ID: number
	SHORT_NAME: string
	CODE: string
	BACKGROUND_COLOR: string
	TEXT_COLOR: string
	CUSTOM_LINK: string
	NAME: string
	SORT: number
	ACTIVE_TO: string
}

interface TagProps {
	tag: Tag
}

export const Tag = (props: TagProps) => {
	const { tag } = props
	const { SHORT_NAME, CODE, BACKGROUND_COLOR, TEXT_COLOR, NAME, CUSTOM_LINK, ACTIVE_TO } = tag
	const { isMobile } = useMediaQueries()
	const countdownText = useTagTimer(ACTIVE_TO, 'До конца акции')
	// const router = useRouter()

	const link = !!CUSTOM_LINK ? CUSTOM_LINK : `/sales/${CODE}`

	// const onClick = (e: MouseEvent<HTMLDivElement>) => {
	// 	e.stopPropagation()
	// 	router.push(link)
	// }

	const styles = { backgroundColor: BACKGROUND_COLOR, color: TEXT_COLOR }
	const target = isMobile ? '_self' : '_blank'
	const trigger = isMobile ? 'click' : 'hover'

	return (
		<div className={clsx(cl.root, cl.tag)} style={styles}>
			<Popover
				trigger={trigger}
				content={
					<div className={cl.modal}>
						{NAME}
						<div className={cl.bottom}>
							<Link prefetch={false} href={link} target={target}>
								Подробнее
							</Link>
							{countdownText && <span className={cl.timer}>{countdownText}</span>}
						</div>
					</div>
				}
				placement="bottomLeft">
				<span className={cl.tagShortName}>{SHORT_NAME}</span>
			</Popover>
		</div>
	)
}
